import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
});

export function authHeaders() {
  const token = localStorage.getItem('pythia_admin_token');
  return token ? { 'X-Admin-Token': token } : {};
}

export function setAdminToken(t) {
  if (t) localStorage.setItem('pythia_admin_token', t);
  else localStorage.removeItem('pythia_admin_token');
}

export function getAdminToken() {
  return localStorage.getItem('pythia_admin_token');
}
